module.exports = __webpack_public_path__ + "47fc1add/img/pdf-icon.79f04a36.svg";